import Text from 'components/Text/Text';
import React from 'react';
import { IRestaurantManagers } from 'types';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './RestaurantManagersList.module.scss';

interface IRestaurantManagersScrollView {
	data: IRestaurantManagers[];
}

const RestaurantManagersScrollView: React.FC<IRestaurantManagersScrollView> = ({ data }) => {
	return (
		<div className={style.container} data-test="RestaurantManagersScrollView">
			{data.length
				? data.map((el) => (
						<div key={el.userId} className={style.item}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#userRolesuperUser`} />
							</svg>
							<Text translationKey={el.firstName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default RestaurantManagersScrollView;
